import PropTypes from 'prop-types';
export const summaryPropTypes = {
  icon: PropTypes.string,
  percent: PropTypes.number,
  heading: PropTypes.string,
  description: PropTypes.string
};